(() => {
  class QuickShop extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-quick-shop-dialog]');
      this.content = this.querySelector('[data-quick-shop-content]');
      this.loading = this.querySelector('[data-quick-shop-loading]');
      this.status = this.querySelector('[data-quick-shop-status]');
      this.productLink = this.querySelector('[data-quick-shop-product-link]');
      this.body = this.querySelector('[data-quick-shop-body]') || this.dialog;
      this.enableButtons();
      this.onSectionLoad = event => this.enableButtons(event.target);
      this.onDocumentClick = event => {
        const trigger = event.target.closest('[data-quick-shop-open]');
        if (trigger) {
          event.preventDefault();
          this.open(trigger);
        }
      };
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.querySelector('[data-quick-shop-close]').addEventListener('click', () => this.dialog.close());
      this.content.addEventListener('product:updated', event => {
        if (event.detail?.url) this.productLink.href = event.detail.url;
        this.placeProductLink();
      });
      this.productLink.addEventListener('click', () => {
        const variantId = this.content.querySelector('product-detail [data-product-form] input[name="id"]')?.value;
        const url = new URL(this.productLink.href);
        url.searchParams.delete('option_values');
        if (variantId) url.searchParams.set('variant', variantId);
        this.productLink.href = url.href;
      });
      this.dialog.addEventListener('close', () => {
        this.controller?.abort();
        this.content.replaceChildren();
        this.trigger?.focus({ preventScroll: true });
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
    }

    enableButtons(root = document) {
      root.querySelectorAll('[data-quick-shop-open]').forEach(button => { button.hidden = false; });
    }

    placeProductLink() {
      const info = this.content.querySelector('.product-info__inner');
      (info || this.body).append(this.productLink);
      const heading = info?.querySelector('.product-info__title');
      if (heading?.id) this.dialog.setAttribute('aria-labelledby', heading.id);
    }

    async open(trigger) {
      const url = new URL(trigger.dataset.productUrl, location.href);
      if (url.origin !== location.origin) return;
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.trigger = trigger;
      this.content.replaceChildren();
      this.status.hidden = true;
      this.loading.hidden = false;
      this.productLink.href = url.href;
      this.productLink.hidden = false;
      this.body.append(this.productLink);
      this.body.scrollTop = 0;
      this.dialog.removeAttribute('aria-labelledby');
      this.dialog.setAttribute('aria-busy', 'true');
      this.dialog.showModal();
      this.dialog.focus({ preventScroll: true });

      try {
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Product request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const detail = page.querySelector('main product-detail');
        if (!detail) throw new Error('Product form missing');
        if (controller.signal.aborted) return;
        detail.dataset.updateUrl = 'false';
        detail.dataset.presentation = 'quick-shop';
        this.content.replaceChildren(detail);
        this.placeProductLink();
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.status.textContent = this.dialog.dataset.error;
          this.status.hidden = false;
        }
      } finally {
        if (this.controller === controller) {
          this.loading.hidden = true;
          this.dialog.removeAttribute('aria-busy');
        }
      }
    }
  }

  if (!customElements.get('quick-shop')) customElements.define('quick-shop', QuickShop);
})();
